import React, { useRef } from 'react';
import './FileUpload.scss';
import { Fab } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';
import { OnFileChange } from 'context/FileContext';

function FileUpload(props: { onChangeFile: OnFileChange; className?: string }): JSX.Element {
  const { onChangeFile, className } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const accept: Readonly<string> = 'image/png, image/jpeg';
  const onClicked = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.click();
    }
  };

  return (
    <article className={`file-upload ${className}`}>
      <Fab variant="extended" className="file-upload-btn" onClick={onClicked}>
        <PublishIcon className="file-upload-btn-icon" />
        업로드
      </Fab>
      <input accept={accept} type="file" ref={inputRef} onChange={onChangeFile} />
    </article>
  );
}

FileUpload.defaultProps = {
  className: false,
};

export default FileUpload;
